import logger from '@/lib/logger';

/**
 * Utility functions for handling CSRF tokens in API requests
 */

/**
 * Get a CSRF token from the dedicated endpoint
 */
export async function getCsrfToken(): Promise<string | null> {
  try {
    const response = await fetch('/api/csrf');
    return response.headers.get('X-CSRF-Token');
  } catch (error) {
    logger.error('Error getting CSRF token:', error);
    return null;
  }
}

/**
 * Make a request with CSRF token
 */
export async function fetchWithCsrf(
  endpoint: string,
  options: RequestInit = {}
): Promise<Response> {
  // For GET requests, just return the regular fetch
  if (options.method === 'GET' || !options.method) {
    return fetch(endpoint, options);
  }

  // For other methods (POST, PUT, DELETE, etc.), get CSRF token first
  const csrfToken = await getCsrfToken();
  if (!csrfToken) {
    throw new Error('Failed to get CSRF token');
  }

  // Add CSRF token to headers
  const headers = new Headers(options.headers || {});
  headers.set('X-CSRF-Token', csrfToken);
  headers.set('Content-Type', 'application/json');

  return fetch(endpoint, {
    ...options,
    headers,
  });
}
